
import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { Region } from '../../../../data/types/region-types';
import { MAPBOX_TOKEN } from '../../../../utils/api-keys';

export const useChurchesMap = (region: Region) => {
  const map = useRef<mapboxgl.Map | null>(null);
  const mapContainer = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!mapContainer.current) return;
    
    console.log("ChurchesMap: Initializing with Mapbox token:", MAPBOX_TOKEN ? "Token exists" : "No token");
    
    mapboxgl.accessToken = MAPBOX_TOKEN;
    
    try {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: region.coordinates,
        zoom: 9,
        preserveDrawingBuffer: true, // This helps with rendering issues in some browsers
      });
      
      map.current.addControl(
        new mapboxgl.NavigationControl(),
        'top-right'
      );
      
      // Handle errors gracefully
      map.current.on('error', (e) => {
        console.error("ChurchesMap error:", e);
      });
    } catch (error) {
      console.error("Error initializing ChurchesMap:", error);
    }

    return () => {
      if (map.current) {
        console.log("ChurchesMap: Cleaning up map instance");
        map.current.remove();
        map.current = null;
      }
    };
  }, [region]);

  return { map, mapContainer };
};
